import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
export function HubLink() {
  return (
    <>
      <Helmet>
        <title>Taters | Tei HubLink Ordering</title>
      </Helmet>

      <Outlet />
    </>
  );
}
